export class CARoute {
  code: string;
  direction: string;
  name: string;
}
